import { ExternalLoginDatasource } from "../datasources/external-login.datasource";
import type { ExternalLoginTokenExchangeDTO } from "../dto/token-exchange.dto";
import type { IExternalLoginRepository } from "./external-login.repository.interface";

export class ExternalLoginRepository implements IExternalLoginRepository {
  constructor(private readonly _remoteDataSource = new ExternalLoginDatasource()) {}

  public async exchangeNonceToken(authenticationToken: string): Promise<ExternalLoginTokenExchangeDTO> {
    return this._remoteDataSource.exchangeNonceToken(authenticationToken);
  }

  public async triggerUpgradeFirstEligibility(nextUrl?: string): Promise<void> {
    return this._remoteDataSource.triggerUpgradeFirstEligibility(nextUrl);
  }
}
